'use client';

import classes from './ServiceOffers.module.scss';
import { IconArrowRight } from '@tabler/icons-react';
import MenuLink from '@/src/components/MenuLink/MenuLink';
import { gaCta } from '@/src/helpers/gtag';
import { useAOS } from '@/src/lib/hooks/useAOS';

type Offer = {
  tag: string;
  title: string;
  problem: string;
  intervention: string;
  result: string;
  ctaLabel: string;
  ctaHref: string;
};

export interface ServiceOffersProps {
  eyebrow?: string;
  title?: string;
  highlightedTitle?: string;
  description?: string;
  offers?: Offer[];
}

export function ServiceOffers({
  eyebrow = 'Nos offres',
  title = 'Trois manières de réduire le risque',
  highlightedTitle = 'de vos projets.',
  description = 'Chaque offre partage la même logique : un périmètre cadré, un interlocuteur unique et des livrables mesurables.',
  offers = [],
}: ServiceOffersProps) {
  useAOS();

  if (!offers || offers.length === 0) {
    return null;
  }

  return (
    <section className={classes.root}>
      <div className={classes.inner}>
        <header className={classes.header} data-aos="fade-up" data-aos-duration="700">
          {eyebrow && <p className={classes.eyebrow}>{eyebrow}</p>}
          <h2 className={classes.title}>
            {title}{' '}
            {highlightedTitle && <span className={classes.highlight}>{highlightedTitle}</span>}
          </h2>
          {description && <p className={classes.description}>{description}</p>}
        </header>

        <div className={classes.grid}>
          {offers.map((offer, index) => (
            <article
              key={offer.title + index}
              className={classes.card}
              data-aos="fade-up"
              data-aos-duration="700"
              data-aos-delay={150 * (index + 1)}
            >
              <div className={classes.cardHeader}>
                <span className={classes.tag}>{offer.tag}</span>
                <h3 className={classes.cardTitle}>{offer.title}</h3>
              </div>

              <div className={classes.cardBody}>
                <div className={classes.row}>
                  <span className={classes.label}>Problème</span>
                  <p>{offer.problem}</p>
                </div>
                <div className={classes.row}>
                  <span className={classes.label}>Intervention</span>
                  <p>{offer.intervention}</p>
                </div>
                <div className={classes.row}>
                  <span className={classes.label}>Résultat</span>
                  <p>{offer.result}</p>
                </div>
              </div>

              <div className={classes.cardFooter}>
                <MenuLink
                  href={offer.ctaHref}
                  className={classes.cta}
                  onClick={() => gaCta(offer.ctaLabel, 'service_offer_cta', offer.ctaHref)}
                >
                  {offer.ctaLabel}
                  <IconArrowRight size={16} />
                </MenuLink>
              </div>
            </article>
          ))}
        </div>
      </div>
    </section>
  );
}
